'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input2 = require('./Input');

var _Input3 = _interopRequireDefault(_Input2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Textarea = (_temp = _class = function (_Input) {
  (0, _inherits3.default)(Textarea, _Input);

  function Textarea() {
    (0, _classCallCheck3.default)(this, Textarea);
    return (0, _possibleConstructorReturn3.default)(this, _Input.apply(this, arguments));
  }

  Textarea.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        path = _props.path,
        debounce = _props.debounce,
        type = _props.type,
        group = _props.group,
        rest = (0, _objectWithoutProperties3.default)(_props, ['path', 'debounce', 'type', 'group']);

    var value = this.getValue();

    return _react2.default.createElement('textarea', (0, _extends3.default)({}, rest, {
      className: this.getClassName(),
      name: path,
      onChange: function onChange() {
        return _this2.onChange.apply(_this2, arguments);
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress,
      value: value
    }));
  };

  return Textarea;
}(_Input3.default), _class.propTypes = (0, _extends3.default)({}, _Input3.default.propTypes, {
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
}), _temp);
exports.default = Textarea;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Textarea.js
 ** module id = 614
 ** module chunks = 0
 **/